import { NgModule } from '@angular/core';

import { IntButtonComponent } from './int-button.component';
import {CommonModule} from "@angular/common";



@NgModule({
    declarations: [
        IntButtonComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        IntButtonComponent
    ]
})
export class IntButtonModule { }
